<template>
	<div class="EntryTableEditor">
		<div style="overflow-x: auto;" v-if="entryIds">
			<table>
				<!-- TODO: multi locale as multiple rows?
					:locale="locale"
					:localeObject="localeLookup[locale]"
				-->
				<EntryTableEditorRow
					v-for="entryId of entryIds" :key="entryId"
					:entryId="entryId"
					@subedit="forwardSubedit"
					@subeditAsset="forwardSubeditAsset"
				/>
			</table>
		</div>
		<!--
		<StackingView
			ref="view"
			:link="{ id: $route.params.id, type: 'Entry' }"
			sysType="entry"
			@close="$router.push(base + '/entries')"
		/>
		-->
	</div>
</template>

<script>
// TODO: how to get the list of entry ids to edit?
//       only support a type parameter for now?
//       comma separated id list as param?
//       should we rather support a search/filter as input? then we could reload to show newly added entries
// TODO: allow to select which columns to show?
// TODO: ordering by column value would be cool - but near impossible?
// TODO: update status + publish button per row
// TODO: make sure all entries have same type
// TODO: header row
// TODO: allow to make column smaller

import EntryTableEditorRow from './EntryTableEditorRow.vue'
import StackingView from './StackingView.vue'

export default {
	name: 'EntryTableEditor',
	components: { EntryTableEditorRow, StackingView },
	inject: [ 'endpoint' ],
	params: {
		contentTypeId: Array,
	},
	data: () => ({
		// TODO: get in as params
		entryIds: null,
		limit: 100,
	}),
	methods: {
		forwardSubedit(link, callback) {
			if (link.linkType == 'Asset') {
				this.$emit('subeditAsset', link, callback)
				return
			}
			this.$emit('subedit', link, callback)
		},
		forwardSubeditAsset(link, callback) {
			this.$emit('subeditAsset', link, callback)
		},
		async getEntryIdsForContentType(contentTypeId) {
			// TODO: get list of ids for content type
			/*
curl 'https://cma.contenthub.dev/spaces/bali6j22f8ll/environments/world/entries?limit=100&skip=0&select=sys%2Cmetadata&sys.archivedAt%5Bexists%5D=false&order=-sys.updatedAt' \
  -H 'as-use: ch' \
  -H 'authorization: Bearer ... \
  -H 'content-type: application/json' \
			*/
			const response = await this.$httpGet(`${this.endpoint}/entries`, {
				limit: this.limit,
				skip: 0,
				select: 'sys,metadata',
				'sys.archivedAt[exists]': false,
				'content_type': contentTypeId,
				//order: '-sys.updatedAt',
				order: 'fields.title',
			})
			return response.items.map(item => item.sys.id)
		},
	},
	async mounted() {
		const ids = await this.getEntryIdsForContentType('contract')
		this.entryIds = ids
	},
}
</script>